'use strict'

module.exports = {
  DEFAULT : 'f8d07f70-2957-11ec-913c-fb51b9a4a85c',
};
